var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back 1",
    clipPath: "url(#clip0_338_48272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.679 26.2423C27.2818 26.2423 26.9369 25.9551 26.8705 25.5568C26.2786 22.1004 22.9316 16.0679 14.4416 15.7153V20.1501C14.4416 20.4574 14.2699 20.7389 13.9967 20.8795C13.7234 21.0201 13.3945 20.9962 13.1445 20.8176L0.843492 12.0312C0.627914 11.8772 0.5 11.6285 0.5 11.3636C0.5 11.0986 0.627914 10.85 0.843492 10.6961L13.1446 1.90965C13.3945 1.73104 13.7235 1.70714 13.9967 1.84775C14.2699 1.98835 14.4416 2.26988 14.4416 2.57717V7.07877C19.6896 7.60224 28.5 11.3903 28.5 25.4219C28.5 25.8488 28.1727 26.2043 27.7473 26.2395C27.7244 26.2413 27.7016 26.2423 27.679 26.2423Z",
    fill: "#FEC601"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_48272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.c28a85e7ac6ef567f09436bf4c52f100.svg";
export { ForwardRef as ReactComponent };